import { render, staticRenderFns } from "./MallIntegral.vue?vue&type=template&id=667c409d&scoped=true&"
import script from "./MallIntegral.vue?vue&type=script&lang=ts&"
export * from "./MallIntegral.vue?vue&type=script&lang=ts&"
import style0 from "./MallIntegral.vue?vue&type=style&index=0&id=667c409d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c409d",
  null
  
)

export default component.exports